<template>
  <div>
    <div class="lg:mb-4 flex mx-2 flex-row flex-wrap items-center justify-end overflow-x-auto">
      <div class="px-2 mt-4 mb-2 lg:mb-0">
        <base-table-pagination-mini
          :total="total"
          :currentPage="currentPage"
          :perPage="perPage"
          @changeCurrentPage="changeCurrentPage"
        ></base-table-pagination-mini>
      </div>
    </div>
    <BaseAccessibleTable
      class="m-2 pr-2"
      :rows="tableData"
      :columns="tableColumns"
      :enableScroll="true"
      :maxBodyHeight="350"
      sortKey="ultimaConexion"
      :sortOrder="ariaSortLabel"
      theadClass="border-b-2"
      @sort-click="handleSortClick"
    >
      <template #header-Estado>
        <span class="sr-only">{{ $t('dashboard.connected_users_col_status') }}</span>
      </template>

      <template #cell-Estado="{ row }">
        <div class="flex justify-center items-center">
          <base-connection-dot :connected="row.Estado === true" />
        </div>
      </template>

      <template #cell-Usuario="{ row }">
        <span class="font-semibold">{{ row.Usuario }}</span>
      </template>

      <template #header-UltimaConexion>
        <span class="inline-flex items-center justify-end w-full cursor-pointer">
          <span>{{ $t('dashboard.connected_users_col_last_connection') }}</span>
          <span class="ml-1 text-xs" aria-hidden="true">
            {{ isAscendingInternal ? '▲' : '▼' }}
          </span>
        </span>
      </template>

      <template #cell-UltimaConexion="{ row }">
        {{ formatDate(row.UltimaConexion) }}
      </template>
    </BaseAccessibleTable>
  </div>
</template>

<script>
import { formatLastConnection } from '@/utils/utils'

export default {
  name: 'connected-users-table',
  components: {
    BaseAccessibleTable: () => import('../tables/BaseAccessibleTable.vue')
  },
  props: {
    // Cada fila: { id, connected: Boolean, usuario, rol, ultimaConexion }
    tableData: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 100
    },
    ascendingOrder: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isAscendingInternal: this.ascendingOrder
    }
  },
  computed: {
    tableColumns () {
      return [
        { key: 'Estado', label: this.$t('dashboard.connected_users_col_status'), width: '50px', align: 'center' },
        { key: 'Usuario', label: this.$t('dashboard.connected_users_col_user'), minWidth: '170px', align: 'left' },
        { key: 'Rol', label: this.$t('dashboard.connected_users_col_role'), minWidth: '120px', align: 'left' },
        { key: 'UltimaConexion', label: this.$t('dashboard.connected_users_col_last_connection'), width: '200px', align: 'right', sortable: true }
      ]
    },
    ariaSortLabel () {
      return this.isAscendingInternal ? 'ascending' : 'descending'
    }
  },
  watch: {
    ascendingOrder (val) {
      this.isAscendingInternal = val
    }
  },
  methods: {
    formatDate: formatLastConnection,
    changeCurrentPage (numPage) {
      this.$emit('changeCurrentPage', numPage)
    },
    handleSortClick () {
      this.isAscendingInternal = !this.isAscendingInternal
      this.$emit('changeAscendingOrder', this.isAscendingInternal)
    }
  }
}
</script>
